import { i18n } from '~/utils';

export const REPROCESSING_INVOICE_ORDER_BY_LABELS = {
  created_on: i18n.t(($) => $.orderBy.createdOn, {
    ns: 'invoiceReprocessing',
  }),
  process_finished_on: i18n.t(($) => $.orderBy.processFinishedOn, {
    ns: 'invoiceReprocessing',
  }),
} as const;

export const REPROCESSING_INVOICE_CHANNEL_LABELS = {
  admin_upload: i18n.t(($) => $.channel.adminUpload, {
    ns: 'invoiceReprocessing',
  }),
  api: i18n.t(($) => $.channel.api, {
    ns: 'invoiceReprocessing',
  }),
  email: i18n.t(($) => $.channel.email, {
    ns: 'invoiceReprocessing',
  }),
  test: i18n.t(($) => $.channel.test, {
    ns: 'invoiceReprocessing',
  }),
} as const;

export const REPROCESSING_INVOICE_STATUS_LABELS = {
  ai_data_error: i18n.t(($) => $.invoiceStatus.aiDataError, {
    ns: 'invoiceReprocessing',
  }),
  ai_parsing_error: i18n.t(($) => $.invoiceStatus.aiParsingError, {
    ns: 'invoiceReprocessing',
  }),
  ambiguous_ai_files_error: i18n.t(
    ($) => $.invoiceStatus.ambiguousAiFilesError,
    {
      ns: 'invoiceReprocessing',
    },
  ),
  ambiguous_files_error: i18n.t(($) => $.invoiceStatus.ambiguousFilesError, {
    ns: 'invoiceReprocessing',
  }),
  automatically_forwarded: i18n.t(
    ($) => $.invoiceStatus.automaticallyForwarded,
    {
      ns: 'invoiceReprocessing',
    },
  ),
  company_matching_error: i18n.t(($) => $.invoiceStatus.companyMatchingError, {
    ns: 'invoiceReprocessing',
  }),
  delayed: i18n.t(($) => $.invoiceStatus.delayed, {
    ns: 'invoiceReprocessing',
  }),
  directly_forwarded: i18n.t(($) => $.invoiceStatus.directlyForwarded, {
    ns: 'invoiceReprocessing',
  }),
  done: i18n.t(($) => $.invoiceStatus.done, { ns: 'invoiceReprocessing' }),
  failed_to_attach_mail_to_process_error: i18n.t(
    ($) => $.invoiceStatus.failedToAttachMailToProcessError,
    { ns: 'invoiceReprocessing' },
  ),
  failed_to_send_mail_error: i18n.t(
    ($) => $.invoiceStatus.failedToSendMailError,
    { ns: 'invoiceReprocessing' },
  ),
  handed_off: i18n.t(($) => $.invoiceStatus.handedOff, {
    ns: 'invoiceReprocessing',
  }),
  handoff_failed: i18n.t(($) => $.invoiceStatus.handoffFailed, {
    ns: 'invoiceReprocessing',
  }),
  in_process: i18n.t(($) => $.invoiceStatus.inProcess, {
    ns: 'invoiceReprocessing',
  }),
  invalid_attachments_error: i18n.t(
    ($) => $.invoiceStatus.invalidAttachmentsError,
    {
      ns: 'invoiceReprocessing',
    },
  ),
  invalid_azure_response_error: i18n.t(
    ($) => $.invoiceStatus.invalidAzureResponseError,
    { ns: 'invoiceReprocessing' },
  ),
  invoice_data_error: i18n.t(($) => $.invoiceStatus.invoiceDataError, {
    ns: 'invoiceReprocessing',
  }),
  invoice_process_stopper_error: i18n.t(
    ($) => $.invoiceStatus.invoiceProcessStopperError,
    { ns: 'invoiceReprocessing' },
  ),
  manually_dismissed: i18n.t(($) => $.invoiceStatus.manuallyDismissed, {
    ns: 'invoiceReprocessing',
  }),
  no_ai_model_settings_error: i18n.t(
    ($) => $.invoiceStatus.noAiModelSettingsError,
    {
      ns: 'invoiceReprocessing',
    },
  ),
  no_parser_found_error: i18n.t(($) => $.invoiceStatus.noParserFoundError, {
    ns: 'invoiceReprocessing',
  }),
  unauthorized_sender_error: i18n.t(
    ($) => $.invoiceStatus.unauthorizedSenderError,
    {
      ns: 'invoiceReprocessing',
    },
  ),
  unknown_auto_forwarding_receiver_error: i18n.t(
    ($) => $.invoiceStatus.unknownAutoForwardingReceiverError,
    {
      ns: 'invoiceReprocessing',
    },
  ),
  unknown_error: i18n.t(($) => $.invoiceStatus.unknownError, {
    ns: 'invoiceReprocessing',
  }),
  unknown_receiver_error: i18n.t(($) => $.invoiceStatus.unknownReceiverError, {
    ns: 'invoiceReprocessing',
  }),
  waiting_for_add_email: i18n.t(($) => $.invoiceStatus.waitingForAddEmail, {
    ns: 'invoiceReprocessing',
  }),
  waiting_for_ai_parsing: i18n.t(($) => $.invoiceStatus.waitingForAiParsing, {
    ns: 'invoiceReprocessing',
  }),
  waiting_for_attaching_mail_to_process: i18n.t(
    ($) => $.invoiceStatus.waitingForAttachingMailToProcess,
    { ns: 'invoiceReprocessing' },
  ),
  waiting_for_auto_forwarding: i18n.t(
    ($) => $.invoiceStatus.waitingForAutoForwarding,
    {
      ns: 'invoiceReprocessing',
    },
  ),
  waiting_for_invoice_service_handoff: i18n.t(
    ($) => $.invoiceStatus.waitingForInvoiceServiceHandoff,
    { ns: 'invoiceReprocessing' },
  ),
  waiting_for_parsing: i18n.t(($) => $.invoiceStatus.waitingForParsing, {
    ns: 'invoiceReprocessing',
  }),
  waiting_for_sending: i18n.t(($) => $.invoiceStatus.waitingForSending, {
    ns: 'invoiceReprocessing',
  }),
};
